import React from 'react';
import _round from 'lodash/round';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWallet } from '@fortawesome/pro-light-svg-icons';

import { Card, getLastBalanceAddedDate } from 'common/api/e-comm/models/Card';
import { createStyle, createStyles } from 'utils/createStyle';
import { LinkBtn } from 'components/link-btn';
import { colors } from 'styles/settings';

const style = createStyles({
    title: createStyle('font-bold text-brand-dark ml-2 align-middle', { lineHeight: '3rem' }),
});

export interface InMyWalletProps {
    items: Card[];
    brandName: string;
    onClick: (card: Card) => void;
}
const renderCard = (card: Card, brandName: string, onClick: (card: Card) => void) => {
    const balance = card.cardBalance ? _round(card.cardBalance || 0, 2).toFixed(2) : '--.--';
    return (
        <li key={card.id}>
            <LinkBtn className="no-underline" onClick={() => onClick(card)}>
                {card.name || brandName} - ${balance}
            </LinkBtn>{' '}
        </li>
    );
};

export const InMyWallet = ({ items, brandName, onClick }: InMyWalletProps) => {
    const itemsSorted = items
        .sort((a, b) => getLastBalanceAddedDate(b).getTime() - getLastBalanceAddedDate(a).getTime())
        .slice(0, 10);

    return (
        <div className="mb-4">
            {itemsSorted.length > 0 && (
                <>
                    <div>
                        <div className="align-center">
                            <FontAwesomeIcon
                                icon={faWallet}
                                color={colors.brandDark}
                                size="lg"
                                className="inline-block"
                            />
                            <span className={style.title}>In my wallet</span>
                        </div>
                        <ul className="ml-7 text-sm">
                            {itemsSorted.map((item) => renderCard(item, brandName, onClick))}
                        </ul>
                    </div>
                </>
            )}
        </div>
    );
};
